const createType = type => `CLASSES/${type}`;

export const CLASSES_GET = createType('GET');
export const CLASSES_EDIT = createType('EDIT');
export const CLASSES_CREATE = createType('CREATE');
export const CLASSES_DELETE = createType('DELETE');
